import { render, staticRenderFns } from "./ActivationDeliverablesProvider.vue?vue&type=template&id=61a15561&"
import script from "./ActivationDeliverablesProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationDeliverablesProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports